// src/components/TransparencyPage.jsx
import React from "react";
// import "./TransparencyPage.scss";

const TransparencyPage = () => {
  return (
    <div className="transparency-page">
      <h2>Transparency & Fund Allocation</h2>
      <div>
        <h3>Fund Allocation</h3>
        <p>A pie chart of fund distribution will appear here.</p>
      </div>
      <div>
        <h3>Detailed Breakdown</h3>
        <p>An itemized list of expenditures.</p>
      </div>
      <div>
        <h3>Update Logs</h3>
        <p>Timeline of fund usage and project progress.</p>
      </div>
    </div>
  );
};

export default TransparencyPage;
